import TenantTable from '../component/table/TenantTable'
import { Snackbar, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import TenantModal from '../container/TenantModal'
import { useAppStateContext } from '../util/CommonState'
import { createTenantData, deleteTenantData, getTenantList, updateTenantData } from '../util/tenant/TenantAPIUtil'

const TenantPage = (props) => {
  const [open,setOpen] = useState(false);
  const [rowdata,setRowData] = useState([]);
  const [selectdata,setSelectData] = useState({});
  const [updateData,setUpdateData] = useState({});

  //一覧を取得する際のLoadingイベントを管理する
  const [loading,setLoading] = useState(false);

  const [snackBar,setSnackBar] = useState(false);

  const {value, setValue} = useAppStateContext();

  //データが変更されたらサーバサイドの処理をするために呼び出させる
  useEffect(()=>{
    if(rowdata.length == 0){
      setLoading(true);
      getInitialData();
    }
  },[rowdata]);

  useEffect(()=>{

    if(updateData.id) {
      // TestDataManagement.putTenantData(updateData);
      if(updateData.type == 'create'){
        createTenant(updateData);
      }

      if(updateData.type == 'update'){
        updateTenant(updateData);
      }
      if(updateData.type == 'delete'){
        deleteTenant(updateData);
      }

      setSnackBar(true);
    }
  },[updateData]);

  //Type=Create
  const createTenant = async (row) => {
    createTenantData(row);
  };

  const updateTenant = async (row) => {
    updateTenantData(row);
  }

  const deleteTenant = async (row) => {
    deleteTenantData(row);
  }


  const getInitialData = async () => {

    const list = await getTenantList();
    // const list = await listUsers(typeList[props.index-1]);

    //データ処理
    if(list && list.length >0){
      setRowData((list));

    }else{
      // setSnackBarMsg("セッション切れあるいは通信エラーのためログイン画面に戻ります")
      // setSnackBar(true);
      // props.login(false);
    }
    setLoading(false);
  }



  // TenantModalからの戻り値に対しての処理（データ処理）　サーバサイドへはuseEffectで実施するため識別のためにtypeを設定する
  const onData = (row) =>{
    if(!('type' in row)) {
      row.type = "create";
      row.entrytime = Date.now();
      setUpdateData(row);
      setRowData([...rowdata,row]);
    }else {
      //Updateのためデータを入れ替える。
      const newData = rowdata.map((item) => {
        return row.id == item.id ? row : item
      })
      setRowData(newData);
      setUpdateData(row);
    }
  };

  // == TenantTableでの動作を定義
  const onCreate = () => {
    setSelectData({});
    setOpen(true);
  };

  const onUpdate = (row) =>{
    row.type = "update";
    setSelectData(row);
    setOpen(true);
  }

  const onDelete = (row) => {
    const newData = rowdata.filter((item) => {
      return row.id == item.id ? false : true
    })
    row.type="delete";
    setUpdateData(row);
    setSelectData({});
    setRowData(newData);
  } ;


  return (
    <>
      <Typography variant={'h4'} >テナント管理</Typography>
      <TenantTable loading={loading} data={rowdata} create={onCreate} update={onUpdate} delete={onDelete} />
      <TenantModal open={open} setOpen={setOpen} datafunc={onData} data={selectdata}/>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={snackBar}
        onClose={()=>{setSnackBar(false)}}
        message="データの更新が反映されました"
        key='tenantadd'
      />
    </>
  );
}


export default TenantPage